import { MfaSetupSheet } from '@/components/mfa-setup-sheet';
import { createFileRoute, Outlet, useChildMatches, useRouter } from '@tanstack/react-router';

export const Route = createFileRoute('/(security)/security/_mfa-setup')({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const navigate = Route.useNavigate();
  const step = useChildMatches({
    select: (matches) => matches.at(-1)?.staticData.setupStep,
  });

  return (
    <MfaSetupSheet
      step={step}
      close={() => navigate({ to: '/security' })}
      // ? history.back() restores the previous step along with its location state
      back={() => router.history.back()}
    >
      <Outlet />
    </MfaSetupSheet>
  );
}
